import React, { ChangeEvent, useEffect, useState } from 'react';
import {
	Box,
	Tabs,
	Tab,
	useTheme,
	Typography,
	Container
} from '@mui/material';
import AccountPreferences from './AccountPreferences';
import SignInSecurity from './SignInSecurity';
import OrgNameChange from './orgdetail';

const MyAccount = () => {
	const [tabIndex, setTabIndex] = useState(0);


	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setTabIndex(newValue);
	};

	const OrganizationDetails = () => (
		<OrgNameChange />
	);
	return (
		<Container maxWidth="xl">
			<Typography variant="h4" sx={{ fontWeight: 'bold', color: 'text.primary', mt: 2 }}>
				Account settings
			</Typography>
			<Typography variant="body2" sx={{ mb: 4 }}>
				Manage your account, organization, and choose your preferences
			</Typography>
		<Box sx={{ width: '100%', typography: 'body1' }}>
			<Tabs
				value={tabIndex}
				onChange={handleTabChange}
				variant="scrollable"
				scrollButtons="auto"
				textColor="primary"
				indicatorColor="primary"
				aria-label="account tabs"
				sx={{
					borderBottom: 1,
					borderColor: 'divider',
					'& .MuiTab-root': {
						minWidth: { xs: 120, sm: 160 },
					},
				}}
			>
				<Tab label="Account Preferences" />
				<Tab label="Sign In and Security" />
				<Tab label="Organization Details" />
			</Tabs>
			<Box sx={{ mt: 2 }}>
				{tabIndex === 0 && <AccountPreferences />}
				{tabIndex === 1 && <SignInSecurity />}
				{tabIndex === 2 && <OrganizationDetails />}
			</Box>
			</Box>
		</Container>
	)
}

export default MyAccount;